

import { useNavigate, useParams } from "react-router-dom";
import { DetallesDeOp, FormularioCrearAbono, TablaAbonosAOP } from "../components";
import { LayoutDesplegable } from "../../layouts";
import { useAbonosXOp, useOPXID } from "../../../hooks/cache";
import { CargandoMedio, ModalFormulario, ModalVerImagen } from "../../components";
import { iconos } from "../../../data";
import { useImagenStore, useModalStore } from "../../../stores";




export const AbonosDeOpNueva = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { imagen } = useImagenStore();
    const { data:op } = useOPXID(id); 
    const { data, isLoading } = useAbonosXOp(id);
    const { modalFormToggle, modalImagen } = useModalStore();


    const menu = [ 
        { title: 'Crear Abono', action:() => modalFormToggle(true), icon: iconos['plus'] },
        { title: 'Pagina Anterior', action:() => navigate(-1), icon: iconos['back'] },
    ];



    return (

        <LayoutDesplegable titulo="Abonos de O.P." subtitulo={`Información op: ${op?.op}`} menu={menu}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de abonos..." />
            :   <>
                <DetallesDeOp data={data || []} />
                <TablaAbonosAOP data={data || []} />
                </>
            }

            <ModalFormulario titulo="Crear Abono" valor={{}} onClose={() => modalFormToggle(false)}>
                <FormularioCrearAbono />
            </ModalFormulario>

            {(modalImagen) && <ModalVerImagen img={imagen} carpeta={'abonosOp'} /> }
        </LayoutDesplegable>

    )
}
